export default __webpack_public_path__ + "static/media/senal-de-accesibilidad.10686e39.svg";